const baseUrl = '/api/koo';

export async function fallbackLogin() {
  await fetch(`${baseUrl}/oauth/fallback-login`, { method: 'POST' }).then((res) => {
    window.location.href = res.url;
  });
}
